// extracted by mini-css-extract-plugin
module.exports = {"title":"SetPasswordForm_title__3lAV9","submit":"SetPasswordForm_submit__feq8F"};